// /redeem — layout route.
//
// File-route convention: `redeem.tsx` together with `redeem.$code.tsx`
// makes /redeem/$code a CHILD route of /redeem. For the child to mount,
// /redeem must render an <Outlet />.
//
// Previously this file rendered <RedeemFlow /> directly, which meant
// that on /redeem/<code> the parent's RedeemFlow rendered (with no
// urlCode) and the child component never mounted. The bug surfaced as
// "the «Код доступа» field is visible even when the code is in the URL".
//
// Now: the layout is a pass-through <Outlet />, and the no-code variant
// lives in redeem.index.tsx.

import { createFileRoute, Outlet } from "@tanstack/react-router";

// Redeem is locale-independent (the student picks the language inside the
// flow), so the share preview uses the AZ default. RU/EN variants are in the
// PR for review. og:image = a dedicated 1200×630 asset (see public/); without
// this block a shared /redeem/<code> link inherited the root «Yolutap MVP» OG.
const OG_TITLE = "Sənə göndərilən test linki — Yolutap";
const OG_DESC =
  "Bu, Yolutap diaqnostikasını keçmək üçün birdəfəlik fərdi linkdir. Test ~30 dəqiqə çəkir, nəticədə fərdi hesabat alırsan.";
// TODO(owner): commit public/Yolutap_OG_Redeem.png (1200×630) — the binary
// isn't in the repo yet; until then this URL 404s and messengers show no image.
const OG_IMAGE = "https://yolutap.com/Yolutap_OG_Redeem.png";

export const Route = createFileRoute("/redeem")({
  head: () => ({
    meta: [
      { title: OG_TITLE },
      { name: "robots", content: "noindex,nofollow" },
      { name: "description", content: OG_DESC },
      { property: "og:title", content: OG_TITLE },
      { property: "og:description", content: OG_DESC },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: OG_TITLE },
      { name: "twitter:description", content: OG_DESC },
      { name: "twitter:image", content: OG_IMAGE },
    ],
  }),
  component: RedeemLayout,
});

function RedeemLayout() {
  return <Outlet />;
}
